<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1>Terms Of Service</h1>
        <TosContent/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import TosContent from "@/components/checkout-wizard/TosContent.vue";

export default {
  name: 'tos',
  components: {TosContent},

  created() {
      document.title = "Terms of Service  - Online Storefront"
  }
}
</script>
